export const SHOP_FILTER_DROPDOWN_QUERY = {
  productsInStore: ["Store Only", "Available for Click and Collect and Store"],
  clickPlusCollectProducts: [
    "Click and Collect Only",
    "Available for Click and Collect and Store",
  ],
  defaultProductType: "allProducts",
} as const;

export const DEFAULT_PRODUCT_TYPE = SHOP_FILTER_DROPDOWN_QUERY.defaultProductType;
